import React from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import classNames from 'classnames';
import DOMPurify from 'dompurify';
import PageLoader from '../components/PageLoader';
import useGetAppAlerts from '../services/useGetAppAlerts';

function AlertNotifications() {
    const {
        appAlertItems,
        appAlertCount,
        isAppAlertsLoading,
        isAppAlertsError,
    } = useGetAppAlerts();

    const formatDate = (dateString) => {
        if (!dateString) return '';
        return String(dateString).split('T')[0];
    };

    const getDisplayDate = (notification) => (
        notification.date ||
        notification.displayFrom ||
        notification.createdOn ||
        notification.dateCreated ||
        notification.updatedOn
    );

    const getDescription = (notification) => (
        notification.description ||
        notification.bodyHtml ||
        notification.body ||
        notification.message ||
        ''
    );

    const getAuthor = (notification) => (
        notification.author ||
        notification.createdBy ||
        notification.modifiedBy ||
        notification.userName ||
        ''
    );

    return (
        <>
            <Row className="p-2">
                <Col>
                    <h2>Alert Notifications</h2>
                </Col>
            </Row>

            <Row className="justify-content-center mt-4">
                <Col md={10} lg={10} xl={8}>
                    <div className="d-flex justify-content-between mb-2">
                        <h4>Alert Notifications</h4>
                        {!isAppAlertsLoading && (
                            <span className="text-muted">{appAlertCount} total</span>
                        )}
                    </div>

                    {isAppAlertsLoading && <PageLoader />}

                    {!isAppAlertsLoading && isAppAlertsError && (
                        <div className="text-center text-muted mt-4">
                            Unable to load alert notifications.
                        </div>
                    )}

                    {!isAppAlertsLoading && !isAppAlertsError && appAlertItems.length === 0 && (
                        <div className="text-center text-muted mt-4">
                            No alert notifications available.
                        </div>
                    )}

                    {!isAppAlertsLoading && !isAppAlertsError &&
                        appAlertItems.map((notification, index) => {
                            const notificationId = notification.id || notification.alertId || notification.appAlertId || index;
                            const notificationType = notification.type || notification.category || 'Alert';
                            const notificationTitle = notification.title || notification.subject || 'Alert Notification';
                            const description = getDescription(notification);
                            const author = getAuthor(notification);

                            return (
                                <Card key={notificationId} className="ribbon-box mb-3">
                                    <CardBody>
                                        <div
                                            className={classNames(
                                                'ribbon',
                                                'ribbon-primary',
                                                'mb-0',
                                                'float-left'
                                            )}
                                        >
                                            <i className="mdi mdi-alert-circle-outline mr-1"></i> {notificationType} - ID: {notificationId}
                                        </div>
                                        <div
                                            className="d-flex justify-content-end align-items-center mb-2"
                                            style={{ gap: '8px' }}
                                        >
                                            <h5 className="mr-2">{notificationTitle}</h5>
                                        </div>
                                        <div
                                            className="ribbon-content"
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(String(description)),
                                            }}
                                        />
                                        <hr />
                                        <div className="text-muted">
                                            {formatDate(getDisplayDate(notification))}
                                            {author && <> - By {author}</>}
                                        </div>
                                    </CardBody>
                                </Card>
                            );
                        })}
                </Col>
            </Row>
        </>
    );
}

export default AlertNotifications;
